import { useContext } from "react";
import { useSelector } from "react-redux";
import { Gantt, Identifiable, Project } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  gantt: Gantt;
  retrieveProjectGantt(
    project: Boundaries["retrieveProjectGantt"]["request"],
  ): void;
}

function useProjectGanttRetrieval(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isProjectGanttRetrievalRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isProjectGanttRetrievalRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isProjectGanttRetrievalRequestFailure(project),
    ),
    gantt: useSelector(() => selector.getProjectGantt(project)),
    retrieveProjectGantt: core.retrieveProjectGantt,
  };
}

export { useProjectGanttRetrieval };
